export const INQUIRY_QUOTE_PERM = {
  /** 菜单 / 路由 */
  menu: 'module:inquiry-quote:inquiry-quote',
  /** 业务类型 Tab */
  tab: {
    sea: 'tab:inquiry-quote-sea:inquiry-quote-sea',
    air: 'tab:inquiry-quote-air:inquiry-quote-air',
    rail: 'tab:inquiry-quote-rail:inquiry-quote-rail',
    prePort: 'tab:inquiry-quote-pre-port:inquiry-quote-pre-port',
    lastMile: 'tab:inquiry-quote-last-mile:inquiry-quote-last-mile'
  },
  role: {
    sea: {
      sales: 'tab:inquiry-quote-sea-sales:inquiry-quote-sea-sales',
      business: 'tab:inquiry-quote-sea-business:inquiry-quote-sea-business'
    },
    air: {
      sales: 'tab:inquiry-quote-air-sales:inquiry-quote-air-sales',
      business: 'tab:inquiry-quote-air-business:inquiry-quote-air-business'
    },
    rail: {
      sales: 'tab:inquiry-quote-rail-sales:inquiry-quote-rail-sales',
      business: 'tab:inquiry-quote-rail-business:inquiry-quote-rail-business'
    },
    prePort: {
      sales: 'tab:inquiry-quote-pre-port-sales:inquiry-quote-pre-port-sales',
      business: 'tab:inquiry-quote-pre-port-business:inquiry-quote-pre-port-business'
    },
    lastMile: {
      sales: 'tab:inquiry-quote-last-mile-sales:inquiry-quote-last-mile-sales',
      business: 'tab:inquiry-quote-last-mile-business:inquiry-quote-last-mile-business'
    }
  },
  /** 各业务 Tab 下「新建询价」 */
  save: {
    sea: 'button:inquiry-quote-sea-save:inquiry-quote-sea-save',
    air: 'button:inquiry-quote-air-save:inquiry-quote-air-save',
    rail: 'button:inquiry-quote-rail-save:inquiry-quote-rail-save',
    prePort: 'button:inquiry-quote-pre-port-save:inquiry-quote-pre-port-save',
    lastMile: 'button:inquiry-quote-last-mile-save:inquiry-quote-last-mile-save'
  }
} as const

export type InquiryQuoteBizTabKey = keyof typeof INQUIRY_QUOTE_PERM.tab

/**
 * 统一运输类型 → 权限用 biz key
 * 兼容列表 tab / 路由 type / 详情 query / 新建 businessType
 */
export function normalizeInquiryQuoteBizTab(biz: string | undefined | null): InquiryQuoteBizTabKey {
  const raw = String(biz || 'sea').trim()
  const map: Record<string, InquiryQuoteBizTabKey> = {
    sea: 'sea',
    fcl: 'sea',
    FCL: 'sea',
    lcl: 'sea',
    LCL: 'sea',
    roro: 'sea',
    bulk: 'sea',
    air: 'air',
    AIR: 'air',
    rail: 'rail',
    RAIL: 'rail',
    prePort: 'prePort',
    preport: 'prePort',
    'pre-port': 'prePort',
    PRE_PORT: 'prePort',
    lastMile: 'lastMile',
    lastmile: 'lastMile',
    'last-mile': 'lastMile',
    LAST_MILE: 'lastMile',
    oncarriage: 'lastMile'
  }
  return map[raw] || 'sea'
}

/** 详情按运输类型落到整箱、拼箱或空运页面。lcl 必须先于 normalize，避免被收成 sea。 */
export function inquiryQuoteDetailRouteName(biz: string | undefined | null): string {
  const raw = String(biz || '').trim().toLowerCase()
  if (raw === 'air') return 'SaasInquiryQuoteAirDetail'
  if (raw === 'lcl') return 'SaasInquiryQuoteLclDetail'
  return 'SaasInquiryQuoteFclDetail'
}

/** 详情/列表/选人弹窗用的角色权限码（按运输类型） */
export function inquiryQuoteRolePerm(
  biz: string | undefined,
  role: 'sales' | 'business'
): string {
  return INQUIRY_QUOTE_PERM.role[normalizeInquiryQuoteBizTab(biz)][role]
}
